import React from 'react';
import { connect } from 'react-redux';
import { favGroupsClient } from 'apollo';
import { Query } from '@apollo/client/react/components';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import * as selectors from 'containers/Groups/selectors';
import * as actions from 'containers/Groups/actions';
import { GET_GROUP_INFO } from 'apollo/queries';
import { getData } from 'utils/functions';
import './styles.scss';

import LoadingSpinner from 'components/LoadingSpinner';
import ViewGroupDetails from './Details';
import { clientIdSelector } from 'store/global/selectors';

interface Props {
  groupId?: string;
  clientId: string;
  show: boolean;
  onGroupSet(group: any): void;
  onClose(): void;
}

const ViewGroupModal: React.FC<Props> = ({ groupId, clientId, show, onGroupSet, onClose }) => {
  const renderBody = () => {
    if (groupId !== null) {
      return (
        /**
         * Avoid using cache on this query otherwise the onCompleted will not be executed
         * and the data will not be loaded into redux
         */
        <Query
          client={favGroupsClient as any}
          fetchPolicy="network-only"
          query={GET_GROUP_INFO}
          variables={{
            client: clientId,
            id: groupId
          }}
          onCompleted={data => {
            onGroupSet(getData(data));
          }}
        >
          {({ data, error = undefined, loading }) => {
            let details = data && data.fetchFilterGroup;
            if (error) {
              return <Alert variant="danger">{error}</Alert>;
            }
            if (loading) {
              return (
                <div className="retrieving-container">
                  <LoadingSpinner message="Retrieving group details..." />
                </div>
              );
            }
            return (
              <div>
                <Modal.Header closeButton>
                  <div>
                    <Modal.Title as="div" bsPrefix="title">
                      {details.name}
                    </Modal.Title>
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <ViewGroupDetails clientId={clientId} data={details} />
                </Modal.Body>
              </div>
            );
          }}
        </Query>
      );
    } else {
      return null;
    }
  };

  return (
    <Modal centered dialogClassName="view-group-modal" show={show} size="lg" onHide={onClose}>
      {renderBody()}
    </Modal>
  );
};

const mapStateToProps = state => ({
  clientId: clientIdSelector(state),
  groupId: selectors.groupIdSelector(state),
  details: selectors.detailsSelector(state),
  show: selectors.showSelector(state)
});

const mapDispatchToProps = dispatch => ({
  onGroupSet: (groupData: any) => {
    dispatch(actions.setGroup(groupData));
  },
  onClose: () => {
    dispatch(actions.setShow(false));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewGroupModal);
